// import { DSMobileEmptyState } from './MobileEmptyState.js';

export { DSMobileEmptyState, DSMobileEmptyStateWithSchema } from './MobileEmptyState.js';
// export default DSMobileEmptyState;
